type Action = { type: string };

export const undoable = (rootReducer: any, bufferSize: number = 100) => {
    let initialState: any;
    let executedActions: Action[] = [];

    return (state: any, action: any) => {
        if (action.type === "MAGIC_BITCH") {
            let newState: any = initialState;

            for (let i = 0; i < executedActions.length; i++) {
                if (executedActions[i] === action.payload) break;
                newState = rootReducer(newState, executedActions[i]);
            }

            return newState;
        }
        executedActions.push(action);
        const updatedState = rootReducer(state, action);

        // Need to be optimized this refers to this task  https://boomformbuilder.atlassian.net/browse/FD-1069
        // Something wrong with buffer size (firt guess)
        // if (executedActions.length === bufferSize + 1) {
        //     const firstAction = executedActions[0];
        //     initialState = rootReducer(initialState, firstAction);
        //     executedActions = executedActions.slice(1, bufferSize + 1);
        // }
        return updatedState;
    };
};

export const undo = (action: Action) => ({ type: "MAGIC_BITCH", payload: action });
